(function () {
  'use strict';

  var menuButton = document.querySelector('.menu-toggle');
  var nav = document.querySelector('#SiteNav');

  if (menuButton && nav) {
    menuButton.addEventListener('click', function () {
      var isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && nav.classList.contains('is-open')) {
        menuButton.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
        menuButton.focus();
      }
    });
  }

  document.querySelectorAll('input[type="number"]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (Number(input.value) < 1 || !input.value) input.value = 1;
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    var price = form && form.closest('.product-info').querySelector('[data-product-price]');
    var addButton = form && form.querySelector('[data-add-button]');
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (addButton) {
        addButton.disabled = option.disabled;
        addButton.textContent = option.disabled ? 'Sold out' : 'Add to cart';
      }
    });
  });
})();
